// extracted by mini-css-extract-plugin
export var slide = "carousel-module--slide--FzDON";
export var slideBackground = "carousel-module--slideBackground--VHa-q";
export var slider = "carousel-module--slider--bB+91";
export var sliderBackground = "carousel-module--sliderBackground--9Vbaz";